// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","blur-circle-shape":"Footer_blur-circle-shape__46yqH"};